<template>
  <div
    class="startContainer center"
    :style="{
      background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${
        selectedBackground.imageFile
          ? selectedBackground.imageFile
          : defaultBackground.imageFile
      }')`,
    }"
    style="
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    "
  >
    <h1 class="text-center" id="title">
      <a @click="$router.push($store.state.routing.homePage)"
        >MARKETING TOOLBOX</a
      >
      <div class="d-flex m-auto justify-content-center flex-wrap">
        <input
          class="form-control mt-5"
          id="searchInput"
          v-on:keyup.enter="
            $router.replace(
              $store.state.routing.homePage +
                `?q=${$store.state.searchedString}`
            )
          "
          v-model="$store.state.searchedString"
        />
        <button
          id="googleSearchbtn"
          class="btn btn-primary h-25 mt-auto mb-0"
          @click="
            $router.replace(
              $store.state.routing.homePage +
                `?q=${$store.state.searchedString}`
            )
          "
        >
          <i class="fa-light fa-magnifying-glass nl-3"></i>
        </button>
      </div>
    </h1>
    <!--Google Search-->
    <!-- <div class="gcse-search"></div> -->

    <StartScreenTools
      class="randomTools"
      :randomTools="$store.state.favoriteTools.slice(0, 8)"
      v-if="$store.state.favoriteTools.length > 0"
    />
    <StartScreenTools
      v-else
      class="randomTools"
      :randomTools="popularTools.slice(0, 8)"
    />
    <button
      id="viewAllToolsBtn"
      @click="this.$router.push($store.state.routing.homePage)"
    >
      View all tools
    </button>
    <footer class="d-flex justify-content-between text-white pl-5 pr-5">
      <LoginPartial @click="setBackground" />
      <BackgroundPartial @click="backgroundChange" :backgrounds="backgrounds" />
    </footer>
  </div>
  <CenteredYungoFooter />
</template>

<script>
import StartScreenTools from "../components/StartScreen/Templates/Body/StartScreenTools.vue";
import LoginPartial from "../components/StartScreen/Templates/Footer/LoginPartial";
import BackgroundPartial from "../components/StartScreen/Templates/Footer/BackgroundPartial";
import CenteredYungoFooter from "../components/CenteredYungoFooter";

export default {
  name: "Start",
  components: {
    CenteredYungoFooter,
    BackgroundPartial,
    LoginPartial,
    StartScreenTools,
  },
  data() {
    return {
      selectedBackground: {},
      defaultBackground: {},
      backgrounds: [],
      searchString: "",
      favoriteTools: [],
      popularTools: [],
    };
  },
  methods: {
    setBackground(value) {
      this.selectedBackground = this.$store.state.backgroundStartScreen;
    },
    async fetchBackgrounds(client) {
      let array = [];
      // gets all valid subcategories from api
      await client
        .getEntries({
          content_type: "background",
        })
        .then(async (entries) => {
          entries.items.forEach((entry) => {
            let obj = {
              imageName: entry.fields.imageName,
              imageFile: entry.fields.imageFile.fields.file.url,
              defaultImage: entry.fields.defaultImage,
            };
            array.push(obj);
          });
          this.backgrounds = array;
        });

      //After fetching, we will set the default background if user has not chosen one before or is not logged in
      this.defaultBackground = this.backgrounds.filter(
        (x) => x.defaultImage === true
      )[0];
    },
    async fetchFavoriteOrPopularTools(client) {
      await this.$store.dispatch("retrieveUserFavoriteTools").then(async () => {
        if (this.$store.state.favoriteTools.length > 0) {
          this.favoriteTools = this.$store.state.favoriteTools.slice(0, 8);
        }
      });
      let array = [];
      await client
        .getEntries({
          content_type: "tool",
          limit: "1000",
        })
        .then(async (entries) => {
          entries.items.forEach((entry) => {
            let logo = "";
            let webprev = "";
            if (entry.fields.logo !== undefined) {
              logo = entry.fields.logo.fields.file.url;
            }
            if (entry.fields.websitePreview !== undefined) {
              webprev = entry.fields.websitePreview.fields.file.url;
            }

            let obj = {
              title: entry.fields.title,
              description: entry.fields.description,
              category: entry.fields.category,
              subdivision: entry.fields.subdivision,
              website: entry.fields.website,
              logo: logo,
              websitePreview: webprev,
              popular: entry.fields.popular,
            };
            array.push(obj);
          });

          let filtered = array.filter((x) => x.popular === true).slice(0, 8);
          if (filtered.length <= 0 || filtered === undefined) {
            this.popularTools = array.slice(0, 8);
          } else {
            this.popularTools = filtered;
          }
        });
    },
    backgroundChange(background) {
      this.selectedBackground = background;
      this.$store.commit("setBackgroundForStartScreen", background.imageFile);
      this.$store.dispatch(
        "updateUserBackgroundImageStart",
        background.imageFile
      );
    },
  },
  beforeMount() {
    let contentful = require("contentful");
    let client = contentful.createClient({
      space: "h0smdghzpqc3",
      accessToken: "L5Tw2h-q6liPo6SB6qG0-h6DYTLEnOmSYeFMzuhEQVw",
    });
    this.fetchBackgrounds(client);
    this.fetchFavoriteOrPopularTools(client);
  },
  mounted() {
    this.$store
      .dispatch("retrieveUserSelectedBackground", localStorage.getItem("email"))
      .then(() => {
        if (this.$store.state.loggedInFirebaseUser) {
          if (this.$store.state.loggedInFirebaseUser[0] === undefined) return;

          let obj = {
            imageFile:
              this.$store.state.loggedInFirebaseUser[0].attributes
                .BackgroundImageStart,
          };

          this.selectedBackground = obj;
        }
      });

    let contentful = require("contentful");
    let client = contentful.createClient({
      space: "h0smdghzpqc3",
      accessToken: "L5Tw2h-q6liPo6SB6qG0-h6DYTLEnOmSYeFMzuhEQVw",
    });
    this.fetchFavoriteOrPopularTools(client);
  },
};
</script>

<style scoped>
button {
  margin-top: -40px;
  margin-bottom: 70px;
  align-self: center;
  height: 48px;
  width: 176px;
  border-radius: 15px;
  background-color: var(--yungo-primary-button);
  outline: none;
  color: white;
  border: none;
  /* margin-top: 60px; */
  justify-content: center;
}

button:hover {
  background-color: var(--yungo-primary-btn-hover);
}

button:active {
  background-color: var(--yungo-primary-btn-click);
}

button:disabled {
  background-color: var(--yungo-primary-btn-disabled);
}

#title {
  padding-bottom: 63px;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 30px;
}

.startContainer {
  display: flex;
  flex-direction: column;
  /* padding-top: 100px; */
  height: 92vh;
  width: 95vw;
  background-color: #13072a;
  border-radius: 25px;
  justify-content: space-evenly;
}

.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#viewAllToolsBtn {
  height: 48px;
  width: 176px;
  border-radius: 15px;
  background-color: var(--yungo-primary-button);
  outline: none;
  color: white;
  border: none;
  align-self: center;
  margin-bottom: 60px;
}

#viewAllToolsBtn:hover {
  background-color: var(--yungo-primary-btn-hover);
}

#viewAllToolsBtn:active {
  background-color: var(--yungo-primary-btn-click);
}

#viewAllToolsBtn:hover {
  background-color: var(--yungo-primary-btn-hover);
}

#viewAllToolsBtn:active {
  background-color: var(--yungo-primary-btn-click);
}

#viewAllToolsBtn:disabled {
  background-color: var(--yungo-primary-btn-disabled);
}

#searchInput {
  width: 360px;
  height: 42px;
  border-radius: 15px;
  margin-right: -50px;
}

#googleSearchbtn {
  border-radius: 15px;
  width: 50px;
  height: 43px !important;
  position: relative;
}

@media only screen and (max-width: 600px) {
  .center {
    left: inherit;
    top: inherit;
    transform: inherit;
  }

  .startContainer {
    padding-top: inherit;
    border-radius: inherit;
    height: 100vh;
    width: 100vw;
  }

  footer {
    flex-wrap: wrap;
    margin-top: -75px;
  }

  #title {
    margin-top: -40px;
    margin-bottom: 40px;
  }

  .allRandomTools {
    margin-bottom: 0px;
    margin-top: -75px;
  }

  #searchInput[data-v-56e8ecd0] {
    width: 300px;
    height: 42px;
    border-radius: 15px;
    margin-right: -50px;
  }
}
@media only screen and (max-width: 400px) {
  #searchInput[data-v-56e8ecd0] {
    width: 260px;
  }
}
</style>